(function () {
  'use strict';

  var TRANSLATIONS = {
    en: {
      label: 'Enter your model number',
      placeholder: 'e.g. C32RTS',
      resultsFound: '{count} result(s) found',
      noResults: 'No instruction book found for this model number.',
      fallback: 'Not available in the selected language. Showing English results.',
      networkError: 'Unable to search at this time. Please try again later.',
      startOver: 'Search again'
    },
    fr: {
      label: "Entrez votre numéro de modèle",
      placeholder: 'ex. C32RTS',
      resultsFound: '{count} r\u00e9sultat(s) trouv\u00e9(s)',
      noResults: "Aucun manuel trouv\u00e9 pour ce num\u00e9ro de mod\u00e8le.",
      fallback: "Non disponible dans la langue s\u00e9lectionn\u00e9e. Affichage des r\u00e9sultats en anglais.",
      networkError: "Impossible d'effectuer la recherche. Veuillez r\u00e9essayer plus tard.",
      startOver: 'Rechercher \u00e0 nouveau'
    },
    es: {
      label: "Introduzca su número de modelo",
      placeholder: 'ej. C32RTS',
      resultsFound: '{count} resultado(s) encontrado(s)',
      noResults: "No se encontr\u00f3 manual para este n\u00famero de modelo.",
      fallback: "No disponible en el idioma seleccionado. Mostrando resultados en ingl\u00e9s.",
      networkError: "No se pudo realizar la b\u00fasqueda. Por favor intente m\u00e1s tarde.",
      startOver: 'Buscar de nuevo'
    },
    it: {
      label: 'Inserisci il numero di modello',
      placeholder: 'es. C32RTS',
      resultsFound: '{count} risultato/i trovato/i',
      noResults: 'Nessun manuale trovato per questo numero di modello.',
      fallback: 'Non disponibile nella lingua selezionata. Visualizzazione dei risultati in inglese.',
      networkError: 'Impossibile effettuare la ricerca. Riprova pi\u00f9 tardi.',
      startOver: 'Cerca di nuovo'
    },
    de: {
      label: 'Bitte Modellnummer eingeben',
      placeholder: 'z.B. C32RTS',
      resultsFound: '{count} Ergebnis(se) gefunden',
      noResults: 'Kein Handbuch f\u00fcr diese Modellnummer gefunden.',
      fallback: 'Nicht in der gew\u00e4hlten Sprache verf\u00fcgbar. Englische Ergebnisse werden angezeigt.',
      networkError: 'Suche derzeit nicht m\u00f6glich. Bitte versuchen Sie es sp\u00e4ter erneut.',
      startOver: 'Erneut suchen'
    },
    nl: {
      label: 'Voer uw modelnummer in',
      placeholder: 'bijv. C32RTS',
      resultsFound: '{count} resultaat/resultaten gevonden',
      noResults: 'Geen handleiding gevonden voor dit modelnummer.',
      fallback: 'Niet beschikbaar in de geselecteerde taal. Engelse resultaten worden weergegeven.',
      networkError: 'Kan momenteel niet zoeken. Probeer het later opnieuw.',
      startOver: 'Opnieuw zoeken'
    }
  };

  var PDF_ICON = 'https://cdn.shopify.com/s/files/1/0860/5256/9431/files/pdf_1.png';
  var OPEN_ICON = 'https://cdn.shopify.com/s/files/1/0860/5256/9431/files/icon_button.png';

  var currentLang = null;
  var flagButtons = document.querySelectorAll('.ib-flag-btn');
  var searchStep = document.getElementById('ib-search-step');
  var searchForm = document.getElementById('ib-search-form');
  var searchInput = document.getElementById('ib-search-input');
  var searchBtn = document.getElementById('ib-search-btn');
  var btnIcon = document.querySelector('.ib-search-btn-icon');
  var btnLoading = document.querySelector('.ib-search-btn-loading');
  var messageEl = document.getElementById('ib-message');
  var resultsEl = document.getElementById('ib-results');
  var resultsHeading = document.getElementById('ib-results-heading');
  var resultsList = document.getElementById('ib-results-list');
  var step2Label = document.getElementById('ib-step2-label');

  /* Helper: Get translation string */
  function t(key, replacements) {
    var lang = currentLang || 'en';
    var str = TRANSLATIONS[lang][key] || TRANSLATIONS.en[key] || key;
    if (replacements) {
      Object.keys(replacements).forEach(function (k) {
        str = str.replace('{' + k + '}', replacements[k]);
      });
    }
    return str;
  }

  function restart() {
    currentLang = null;

    // Deselect all flags
    flagButtons.forEach(function (btn) {
      btn.setAttribute('aria-pressed', 'false');
    });

    // Hide search form, results, messages
    searchStep.setAttribute('hidden', '');
    hideMessage();
    hideResults();

    // Reset input
    searchInput.value = '';
  }

  function selectLanguage(lang) {
    currentLang = lang;

    // Update flag states
    flagButtons.forEach(function (btn) {
      var isSelected = btn.getAttribute('data-lang') === lang;
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    // Update step label
    if (step2Label) step2Label.textContent = t('label');

    // Show search form and update text
    searchStep.removeAttribute('hidden');
    searchInput.setAttribute('placeholder', t('placeholder'));
    searchInput.setAttribute('aria-label', t('label'));

    // Clear previous results and messages
    hideMessage();
    hideResults();

    // Focus input
    searchInput.focus();
  }

  function handleSearch(e) {
    e.preventDefault();

    var query = searchInput.value.trim();

    if (!query || query.length < 2) {
      searchInput.classList.add('ib-search-input--error');
      return;
    }
    searchInput.classList.remove('ib-search-input--error');

    if (!currentLang) {
      return;
    }

    setLoading(true);
    hideMessage();
    hideResults();

    var url = '/apps/manuals/search?q=' + encodeURIComponent(query) + '&lang=' + encodeURIComponent(currentLang);

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        setLoading(false);

        if (!data.results || data.results.length === 0) {
          showMessageWithRestart(t('noResults'), 'error');
          return;
        }

        // Show fallback notice if results are English fallback
        if (data.fallback) {
          showMessage(t('fallback'), 'fallback');
        }

        renderResults(data.results, data.fallback);
      })
      .catch(function () {
        setLoading(false);
        showMessageWithRestart(t('networkError'), 'error');
      });
  }

  function renderResults(results, isFallback) {
    resultsList.innerHTML = '';

    results.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'ib-result-card';

      var badgeHtml = '';
      if (isFallback) {
        badgeHtml = '<span class="ib-lang-badge">' + escapeHtml(item.language.toUpperCase()) + '</span>';
      }

      card.innerHTML =
        '<div class="ib-result-info">' +
          '<div class="ib-pdf-icon">' +
            '<img src="' + PDF_ICON + '" alt="PDF">' +
          '</div>' +
          '<div>' +
            '<span class="ib-model-name">' + escapeHtml(item.model) + '</span>' +
            badgeHtml +
          '</div>' +
        '</div>' +
        '<div class="ib-result-actions">' +
          '<a href="' + escapeHtml(item.url) + '" target="_blank" rel="noopener" class="ib-btn-open" aria-label="Open PDF">' +
            '<img src="' + OPEN_ICON + '" alt="Open PDF">' +
          '</a>' +
        '</div>';

      resultsList.appendChild(card);
    });

    resultsHeading.textContent = t('resultsFound', { count: results.length });
    resultsEl.removeAttribute('hidden');
  }

  function showMessage(text, type) {
    messageEl.innerHTML = escapeHtml(text);
    messageEl.className = 'ib-message ib-message--' + type;
    messageEl.removeAttribute('hidden');
  }

  function showMessageWithRestart(text, type) {
    messageEl.innerHTML = escapeHtml(text) +
      ' <a href="#" class="ib-restart-link" id="ib-restart-btn">' + t('startOver') + '</a>';
    messageEl.className = 'ib-message ib-message--' + type;
    messageEl.removeAttribute('hidden');

    var restartBtn = document.getElementById('ib-restart-btn');
    if (restartBtn) {
      restartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        restart();
      });
    }
  }

  function hideMessage() {
    messageEl.setAttribute('hidden', '');
    messageEl.innerHTML = '';
    messageEl.className = 'ib-message';
  }

  function hideResults() {
    resultsEl.setAttribute('hidden', '');
    resultsList.innerHTML = '';
    resultsHeading.textContent = '';
  }

  function setLoading(loading) {
    searchBtn.disabled = loading;
    searchInput.disabled = loading;

    if (loading) {
      btnIcon.setAttribute('hidden', '');
      btnLoading.removeAttribute('hidden');
    } else {
      btnIcon.removeAttribute('hidden');
      btnLoading.setAttribute('hidden', '');
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  flagButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectLanguage(btn.getAttribute('data-lang'));
    });
  });

  if (searchForm) {
    searchForm.addEventListener('submit', handleSearch);
  }

  searchInput.addEventListener('input', function () {
    searchInput.classList.remove('ib-search-input--error');
  });

})();
